import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { SubmitHandler, useForm } from "react-hook-form"
import { closeRejectApplicationModal, fetchRejectApplication, rejectApplicationSchema, selectOnReject, selectRejectJobApplicationModalOpen } from "../../model"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormInput } from "@/shared/ui/form-input"

interface RejectJobApplicationFormValues {
    comment: string
}

const initialState: RejectJobApplicationFormValues = {
    comment: ""
}

export const RejectJobApplicationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectRejectJobApplicationModalOpen)
    const onReject = useAppSelector(selectOnReject)

    const handleClose = () => {
        dispatch(closeRejectApplicationModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchRejectApplication(data.comment))
                .unwrap()
                .then(() => {
                    notify.success('Заявка успешно отклонена')
                    reset()
                    onReject?.()
                    handleClose()
                    res('')
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        register,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(rejectApplicationSchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title="Отклонение заявки"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    label={"Комментарий"}
                    id={"comment"}
                    rows={3}
                    maxLength={2048}
                    type="textarea"
                    error={errors['comment']}
                    required={true}
                    placeholder="Введите комментарий"
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Подтвердить
                    </button>
                </div>
            </form>
        </Modal>
    )
}